import { render, staticRenderFns } from "./TrademarkSearchList.vue?vue&type=template&id=20dce848&"
import script from "./TrademarkSearchList.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchList.vue?vue&type=style&index=0&id=20dce848&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports